import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import VLPExtent from "./VLPExtent";
import VLP from "./VLP";
import ChangePassword from "./components/authorization/ChangePassword";
import UnderMaintenance from "./components/common/UnderMaintenance";
import Login from "./components/authorization/Login";
import { NotificationContainer } from "react-notifications";
import { GetLoggedInUser } from "./services/usersService";
import useSessionExpiryWarnings from "./hooks/useSessionExpiryWarnings";
import useCrossTabAuthSync from "./hooks/useCrossTabAuthSync";

export default function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [isPasswordExpired, setIsPasswordExpired] = useState(false);
  useSessionExpiryWarnings();
  useCrossTabAuthSync();
  useEffect(() => {
    const checkLoggedInUser = async () => {
      const now = Date.now().valueOf();

      try {
        const loggedInUser = await GetLoggedInUser();
        if (loggedInUser !== undefined && loggedInUser !== null) {
          if (loggedInUser.tokenExpiration) {
            const tokeExp =
              loggedInUser.tokenExpiration &&
              Date.parse(loggedInUser.tokenExpiration);
            if (tokeExp > now) {
              setIsPasswordExpired(loggedInUser.isPasswordExpired);
              setLoggedIn(true);
              
            } else {
              setLoggedIn(false);
            }
          } else {
            setLoggedIn(false);
          }
        } else {
          setLoggedIn(false);
        }
      } catch (error) {
        console.error("Error checking logged-in user:", error);
      }
    };

    checkLoggedInUser();
  }, []);

  return (
    <div>
      <NotificationContainer leaveTimeout={3000} />
      <BrowserRouter>
        {loggedIn ? (
          isPasswordExpired ? (
            <Routes>
              <Route path="*" element={<ChangePassword />} />
            </Routes>
          ) : (
            <Routes>
              {/* <Route path="*" element={<UnderMaintenance />} /> */}
              <Route path="/vlp/*" element={<VLP />} />
              <Route path="/vlp-extend/*" element={<VLPExtent />} />
              <Route path="*" element={<VLP />} />
            </Routes>
          )
        ) : (
          <Login />
        )}
      </BrowserRouter>
    </div>
  );
}
